import {
  AppInput,
  AppButton,
  AppForm,
  AppFormItem,
  AppSelect,
  AppSelectOption,
  AppModal,
  appModal,
  useAppForm
} from '@/shared/ui'
import { FunctionComponent, useState } from 'react'

export type UserClients = {
  id: number
  name: string
  logoUrl: string
}

export type ChangeClientProps = {
  isVisible?: boolean
  userId: string
  firstName?: string
  lastName?: string
  email?: string
  photoUrl?: string
  client?: string
  clients?: UserClients[]
  translate?: (arg0: string) => string
  onImageChange?: () => void
  gotFields?: () => void
  updateUserFunction?: (userId: any, fieldsToUpdate: any) => void
  toClose?: () => void
}
export const ChangeClientModal: FunctionComponent<ChangeClientProps> = ({
  isVisible = false,
  userId = '',
  firstName = '',
  lastName = '',
  email = '',
  photoUrl = '',
  client = '',
  clients = [
    {
      id: 1,
      name: 'Oxxo',
      logoUrl: 'https://logodix.com/logo/1811887.png'
    },
    {
      id: 2,
      name: 'Tottus',
      logoUrl: 'https://lh3.googleusercontent.com/FwH9240KVhk6Up7S1doyFAe0rzPYTTrPcZVdSDQJDW3Bsgtg6R1UxsnLyAIj3jtF8hQ'
    },
    {
      id: 3,
      name: 'Alkosto',
      logoUrl: 'https://d1yjjnpx0p53s8.cloudfront.net/styles/logo-thumbnail/s3/062013/alkosto.png?itok=8zv_3MXU'
    }
  ],
  translate = (arg0: string) => '',
  onImageChange = () => {},
  updateUserFunction = () => {},
  toClose = () => {}
}: ChangeClientProps): JSX.Element => {
  const gotFields = () => {
    return [
      {
        name: ['firstName'],
        value: firstName
      },
      {
        name: ['lastName'],
        value: lastName
      },
      {
        name: ['email'],
        value: email
      }
    ]
  }
  const { info } = appModal
  const [updateUserForm] = useAppForm()
  const [fields, setFields] = useState(gotFields())
  const [uploadBtn, setUploadBtn] = useState({
    value: null
  })

  const updateUser = () => {
    updateUserForm.validateFields().then(async (values) => {
      const { firstName, lastName, clientId } = values
      const fieldsToUpdate = {
        firstName,
        lastName,
        photoUrl: photoUrl,
        clientId
      }
      if (clientId) {
        fieldsToUpdate.clientId = clientId
      }
      updateUserFunction(userId, fieldsToUpdate)
    })
  }

  const onFinishFailed = (info: any) => {
    console.warn('User profile update validation: ', info)
  }

  return (
    <div id='user-update' className='user-panel-update'>
      <AppModal
        title={translate('user-profile.change-client')}
        open={isVisible}
        onCancel={toClose}
        centered={true}
        footer={null}
        keyboard={true}
        maskClosable={true}
        width={500}
        closable={true}
      >
        <AppForm
          form={updateUserForm}
          layout='vertical'
          fields={fields}
          onFinish={updateUser}
          onFinishFailed={onFinishFailed}
        >
          <div hidden={false}>
            <div className='user-form'>
              <AppFormItem label={''} name='clientId' initialValue={firstName ? client : null}>
                <AppSelect>
                  {clients.map(({ id, name, logoUrl }, idx) => (
                    <AppSelectOption key={idx} value={id}>
                      <img src={logoUrl} alt='client-logo' className='client-select-image' /> {name}
                    </AppSelectOption>
                  ))}
                </AppSelect>
              </AppFormItem>
            </div>
            <div className='update-pass-buttons'>
              <AppButton key='back' onClick={toClose}>
                {translate('user-profile.button.cancel')}
              </AppButton>
              <AppFormItem>
                <AppButton htmlType='submit' variant='primary'>
                  {translate('user-profile.button.save')}
                </AppButton>
              </AppFormItem>
            </div>
          </div>
        </AppForm>
      </AppModal>
    </div>
  )
}
